import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

var BlockerContentInlineStyles = /*#__PURE__*/function () {
  function BlockerContentInlineStyles() {
    _classCallCheck(this, BlockerContentInlineStyles);
  }

  _createClass(BlockerContentInlineStyles, null, [{
    key: "inner",
    value: function inner(_ref) {
      var _ref$layout = _ref.layout,
          type = _ref$layout.type,
          dialogBorderRadius = _ref$layout.dialogBorderRadius,
          _ref$design = _ref.design,
          borderWidth = _ref$design.borderWidth,
          borderColor = _ref$design.borderColor,
          textAlign = _ref$design.textAlign,
          fontColor = _ref$design.fontColor,
          fontInheritFamily = _ref$design.fontInheritFamily,
          fontFamily = _ref$design.fontFamily,
          antiAdBlocker = _ref.customCss.antiAdBlocker,
          visualType = _ref.blocker.visualType;
      var hasBg = visualType === "wrapped";
      var style = {
        textAlign: textAlign,
        fontFamily: fontInheritFamily ? undefined : fontFamily,
        color: fontColor,
        // margin: "10px 0",
        borderRadius: type === "dialog" ? +dialogBorderRadius : undefined,
        border: type === "banner" ? borderWidth > 0 ? "".concat(borderWidth, "px solid ").concat(borderColor) : undefined : undefined,
        position: "relative",
        padding: hasBg ? "30px 50px" : undefined,
        overflow: hasBg ? "hidden" : undefined
      };
      return {
        className: "wp-exclude-emoji ".concat(antiAdBlocker === "y" ? "" : "rcb-inner"),
        style: style
      };
    }
  }, {
    key: "innerBackground",
    value: function innerBackground(_ref2) {
      var antiAdBlocker = _ref2.customCss.antiAdBlocker,
          _ref2$blocker = _ref2.blocker,
          visualType = _ref2$blocker.visualType,
          visualThumbnail = _ref2$blocker.visualThumbnail,
          visualBlur = _ref2$blocker.visualBlur;
      var hasBg = visualType === "wrapped";
      var style = {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: hasBg ? "block" : "none",
        filter: visualBlur > 0 ? "blur(".concat(visualBlur, "px)") : undefined
      };

      if (hasBg) {
        style.background = "url('".concat(visualThumbnail.url, "') no-repeat center center");
        style.backgroundSize = "cover";
      }

      return {
        className: antiAdBlocker === "y" ? "" : "rcb-inner-bg",
        style: style
      };
    }
  }, {
    key: "content",
    value: function content(_ref3) {
      var visualType = _ref3.blocker.visualType,
          antiAdBlocker = _ref3.customCss.antiAdBlocker;
      return {
        className: antiAdBlocker === "y" ? undefined : "rcb-content",
        style: {
          boxShadow: visualType === "wrapped" ? "rgb(0 0 0 / 35%) 0px 0px 0px 7px, #0000004d 0px 0px 100px 30px" : undefined,
          position: "relative"
        }
      };
    }
  }]);

  return BlockerContentInlineStyles;
}();

export { BlockerContentInlineStyles };